import { render, staticRenderFns } from "./NotificationsWrapper.vue?vue&type=template&id=c8b584e6"
import script from "./NotificationsWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports